import { Button } from "react-bootstrap";
import { useEffect, useState } from "react";
import "./tableEditable.css";

const LineEditable = (props) => {
        

        //Esse state é responsável por controlar a edição da linha, se for true a linha habilita os campos para edição, se for falso a linha ignora.
        const [edit, setEdit] = useState(false);

        const [pph, setPph] = useState(props.operation.pph);
        const [piece_cicle, setPieceCicle] = useState(props.operation.piece_cicle);
        const [time_wait_piece_cicle, setTimeWaitPieceCicle] = useState(props.operation.time_wait_piece_cicle);

        /*const validationDecimal = ()=>{
            if(pph.toString().slice(-1) == "."){
                console.log("a");
                setPph(parseFloat(pph.toString().slice(0,-1)));
                console.log(pph)
            }
            if(piece_cicle.toString().slice(-1) == "."){
                setPieceCicle(parseFloat(piece_cicle.toString().slice(0,-1)));
            }
        }*/

        const validationNumber = (event)=>{
            // 8 é o backspace, 9 é o tab, 13 é o enter
            // 48 a 57 são os números na linha superior, 96 a 105 são os números no teclado numérico
            if (
                event.which === 8 || // backspace
                event.which === 9 || // tab
                event.which === 13 || // enter
                (event.which >= 48 && event.which <= 57) || // 0-9
                (event.which >= 96 && event.which <= 105) || // 0-9 numpad
                event.which === 144 || // numlock
                event.which === 34 || // pagedown
                (event.which >= 37 && event.which <= 40) || // arrows
                event.which === 110 || // decimal point numpad (.)
                event.which === 190 // decimal point (.)
            ) {
                // Allow the key event
            } else {
                // Prevent all other keys
                event.preventDefault();
            }
        }

        useEffect(()=>{
            setPieceCicle(props.operation.piece_cicle);
            setPph(props.operation.pph);
            setTimeWaitPieceCicle(props.operation.time_wait_piece_cicle);
        }, [props, edit])


        return(

            <>
            <tr>
                <td>
                    {props.operation.operation ? props.operation.operation : props.operation.code}
                </td>
                <td>
                    {props.operation.alternative}
                </td>
                <td>
                    {(edit == true) ? (<input type="number" onChange={(e)=>{setPph(e.target.value)}} className="input-editable" value={pph} onKeyDown={validationNumber}/>) : (props.operation.pph)}
                </td>
                <td>
                    {(edit == true) ? (<input type="number" onChange={(e)=>{setPieceCicle(e.target.value)}} className="input-editable" value={piece_cicle} onKeyDown={validationNumber} />) : (props.operation.piece_cicle)}
                </td>
                <td>
                    {(edit == true) ? (<input type="number" onChange={(e)=>{setTimeWaitPieceCicle(e.target.value)}} className="input-editable" value={time_wait_piece_cicle} onKeyDown={validationNumber} />) : (props.operation.time_wait_piece_cicle)}
                </td>
                <td>
                    {props.operation.machine}
                </td>
                <td className="buttons-editable">
                    <Button style={{backgroundColor: '#05ca83', border: 'unset'}} onClick={()=>{

                        if(edit == false){
                            setEdit(!edit);
                        }else{
                            //If para fazer a validação dos inputs
                           if (
                                pph === null || pph === "" || pph === "." || isNaN(pph) ||
                                piece_cicle === null || piece_cicle === "" || piece_cicle === "." || isNaN(piece_cicle) ||
                                time_wait_piece_cicle === null || time_wait_piece_cicle === "" || time_wait_piece_cicle === "." || isNaN(time_wait_piece_cicle)
                            ) {
                                props.setShow(true);
                                 if (pph === "" || piece_cicle === "" || time_wait_piece_cicle === "") {
                                    props.setMessage("Necessário preencher todos os campos.");
                                }else{

                                    props.setMessage("Erro de validação! Os campos numéricos devem ser preenchidos corretamente.");


                                }

                            }else{
                                if(props.operation.operation){
                                
                                    props.alt(props.operation.operation, props.operation.alternative, pph, piece_cicle, time_wait_piece_cicle);
                                    setPieceCicle(null);
                                    setPph(null);
                                    setTimeWaitPieceCicle(null);
                                }else{
                                    props.alt(props.operation.code, props.operation.alternative, pph, piece_cicle, time_wait_piece_cicle);
                                    
                                }
                                
                                setEdit(false);
                            }
                        }
                        }}
                        >
                        Editar
                    </Button>
                    {(edit == true) ? (
                        <Button style={{backgroundColor: 'red', border: 'unset'}} onClick={()=>{
                            if(props.arrLength > 1){
                                if(props.operation.operation){
                                    setPieceCicle(null);
                                    setPph(null);
                                    setTimeWaitPieceCicle(null);
                                    props.del(props.operation.operation,props.operation.alternative);
                                }else{
                                    props.del(props.operation.code, props.operation.alternative);
                                }
                                
                            }else{
                                props.setShow(true);
                                props.setMessage("Erro ao excluir. O item precisa de ao menos 1 operação.")
                            }

                            setEdit(false)
                            
                        }}>Excluir</Button>
                    ):(
                        null
                    )}
                </td>
            </tr>

            </>
        )
}

export default LineEditable;